var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.someProp.title))]),
    _c("br"),
    _c("span", { staticClass: "use-html" }, [
      _vm._v(_vm._s(_vm.someProp.content)),
    ]),
    _c("br"),
    _c("span", { staticClass: "link-msg", on: { click: _vm.change } }, [
      _vm._v(_vm._s(_vm.someProp.link)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }